import { makeStyles } from "@mui/styles";
import { FontFamilySwitch } from "../../utils";

export const CheckAvailabilityStyles = makeStyles((theme) => ({
    grid_border: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderBottom: "none"
    },
    title: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        fontFamily: FontFamilySwitch().bold,
        textTransform: "uppercase"
    },
    available_slot: {
        // height: "100%"
    },
    venueSection: {
        height: `calc ( 100vh - 200px)`,
        overflow: "auto"
    },
    btnBox: {
        // padding: 4,
        // position: "relative",
        // right: 4,
        // bottom: 8
        position: "absolute",
        bottom: "0px",
        right: "0px",
        width: "100%",
        backgroundColor: "#fff",
        padding: "16px",
        border: `1px solid ${theme.palette.border.secondary}`,
    },
    walkinBtn: {
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().bold,
        '&:hover': {
            background: "transparent"
        }
    },
    noVenueBox:{
        position:"relative",
        height: "calc(100vh - 320px)",
        display:"flex",
        alignItems:"center",
        justifyContent:"center"
    },
    noneTitle: {
        fontSize:"0.875rem",
        color: theme.typography.color.secondary,
        fontFamily: FontFamilySwitch().bold,
    },
}))

export const ViewCourtStyle = makeStyles((theme) => ({
    court_name: {
        fontSize:"1rem",
        color: theme.typography.color.primary,
        fontFamily: FontFamilySwitch().bold
    },
    subname: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        fontFamily: FontFamilySwitch().bold
    },
    title: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        fontFamily: FontFamilySwitch().semiBold,
    },
    content: {
        fontSize:"0.875rem",
        color: theme.typography.color.primary,
        fontFamily: FontFamilySwitch().bold
    },
    contentDay: {
        fontSize:"0.875rem",
        color: theme.typography.color.primary,
        fontFamily: FontFamilySwitch().bold,
        marginInlineStart: "16px"
    },
    court_title: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        fontFamily: FontFamilySwitch().bold
    },
    dot: {
        height: 6,
        width: 6,
        borderRadius: 50,
        background: theme.palette.background.tab_background_1
    },
    subTitle: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        fontFamily: FontFamilySwitch().semiBold,
    },
    seeMoreLessTextStyle: {
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().semiBold,
    },
    description: {
        fontFamily: FontFamilySwitch().regular,
        color: theme.typography.color.secondary,
        fontSize:"0.75rem"
    },
}))

export const BookingResidentPopupStyle = makeStyles((theme) => ({
    name: {
        fontSize:"0.875rem",
        color: theme.typography.color.primary,
        fontFamily: FontFamilySwitch().bold
    },
    content: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary
    },
    border: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderRadius: 4
    },
    title: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        fontFamily: FontFamilySwitch().bold,
        textTransform: "uppercase"
    },
    grid_border: {
        border: `1px solid ${theme.palette.border.secondary}`,
        borderBottom: "none"
    },
    invoiceTitle1: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        fontFamily: FontFamilySwitch().bold
    },
    invoiceTitle2: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        fontFamily: FontFamilySwitch().italic,
    },
    editIcon: {
        cursor: "pointer"
    },
    bookingAvatar: {
        borderRadius: "50px",
        height: 40,
        width: 40,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: theme.palette.success.light
    },
    proceedDialog: {
        padding: "54px 50px 51px 228px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        backgroundImage: `url(${"images/announsment.svg"})`,
        backgroundRepeat: "no-repeat",
        backgroundColor: theme?.palette?.primary?.main
    },
    proceedDialog1: {
        padding: "78px 50px",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        backgroundImage: `url(${"images/success.svg"})`,
        backgroundRepeat: "no-repeat",
        backgroundColor: theme?.palette?.primary?.main
    },
    convert: {
        color: "white",
        fontSize:"1rem",
        fontFamily: FontFamilySwitch().bold,
    },
    convertProcess: {
        color: "white",
        fontSize:"1rem",
        fontFamily: FontFamilySwitch().regular,
        marginTop: '7px'
    },
    yes: {
        color: theme?.palette?.primary?.main,
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().bold,
        border: `1px solid white`,
        backgroundColor: "white",
        padding: "7px 29px",
        width: "100%",
        "&:hover": {
            border: `1px solid white`,
            backgroundColor: "white",
        },
    },
    No: {
        color: "white",
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().semiBold,
        border: `1px solid white`,
        padding: "7px 29px",
        backgroundColor: theme?.palette?.primary?.main,
        marginInlineStart: "10px",
        width: "100%",
        "&:hover": {
            border: `1px solid white`,
            backgroundColor: theme?.palette?.primary?.main,
        },
    },
    publishDialog: {
        '& .MuiPaper-root': {
            background: "transparent !important"
        }
    },
    backBtn: {
        height: 40,
        width: 112,
        color: theme.typography.color.primary,
        fontFamily: FontFamilySwitch().bold,
        fontSize:"0.875rem",
        border: `1px solid ${theme.palette.border.primary}`,
        borderRadius: 4,
        background: "transparent",
        "&:hover": {
            background: "transparent"
        }
    },
    slotLabel: {
        background: theme.palette.info.light,
        color: theme.palette.info.main,
        padding: "2px 4px 2px 4px",
        fontSize:"0.75rem",
        borderRadius: 4,
        fontFamily: FontFamilySwitch().semiBold,
        whiteSpace: "noWrap",
        height: "18px"
    },
    createLabel: {
        fontSize:"0.75rem",
        color: theme.typography.color.tertiary,
        fontFamily: FontFamilySwitch().italic,
    },
    optionAvatar: {
        height: 32,
        width: 32
    },
    optionHeader: {
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().bold,
        color: theme.typography.color.primary
    },
    optionSubTitle: {
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().regular,
        color: theme.typography.color.secondary,
        direction: "ltr"
    },
    btnBox: {
        position: "absolute",
        bottom: "0px",
        right: "0px",
        width: "100%",
        backgroundColor: "#fff",
        padding: "16px",
        border: `1px solid ${theme.palette.border.secondary}`,
    },
    bookBtn: {
        height: 40,
        width: 150,
        borderRadius: 4,
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().bold
    },
    walkinBtn: {
        height: 40,
        width: 150,
        borderRadius: 4,
        fontSize:"0.875rem",
        fontFamily: FontFamilySwitch().bold,
        "&:hover": {
            background: 'transparent'
        }
    }
}))

export const BookingSuccessStyle = makeStyles((theme) => ({
    title: {
        fontSize:"0.875rem",
        color: theme.typography.color.primary,
        fontFamily: FontFamilySwitch().bold
    },
    msgBox: {
        borderRadius: 4,
        background: theme.palette.warning.light,
        width: 300,
        display: "flex",
        textAlign: "center"
    },
    msgBoxText: {
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().semiBold,
        color: theme.palette.warning.main
    },
    invoiceText: {
        fontSize:"0.75rem",
        fontFamily: FontFamilySwitch().italic,
        color: theme.typography.color.tertiary

    }
}))